export default __webpack_public_path__ + "static/media/employeetracker.0008f3de.webp";